<ul class="layout-menu" *ngIf="menuItems$">
  <ng-container *ngFor="let item of menuItems$ | async; let i = index">
    <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
    <li *ngIf="item.separator" class="menu-separator"></li>
  </ng-container>
</ul>

<!-- Trial Subscription Info (at bottom of menu) - Mobile only -->
<div *ngIf="!layoutService.isDesktop() && trialDaysRemaining !== null && trialDaysRemaining !== undefined" class="menu-trial-upgrade">
  <div class="trial-days-text">{{ trialDaysRemaining }} μέρες δοκιμής</div>
  <button pButton type="button" class="upgrade-button" (click)="onUpgradeButtonClick()">
    <i class="pi pi-bolt"></i>
    <span>Αναβάθμιση σε Premium</span>
  </button>
</div>
